import type { AxiosInstance } from "axios"
import handleQueryResult from "./util/handleQueryResult"

export class SsoQueryClient {
	constructor(private axiosClient: AxiosInstance) {}

	public getAuthCode = ({
		professionalEmail,
		responseBody
	}: {
		professionalEmail: string
		responseBody: string
	}) => {
		const params = new URLSearchParams()
		params.append("professionalEmail", professionalEmail)
		params.append("responseBody", responseBody.toString())

		return handleQueryResult(
			this.axiosClient.get<string>(
				`/api/sso/test/code?${params.toString()}`
			)
		)
	}

	public getToken = (body: { code: string; clientSecret: string }) =>
		handleQueryResult(
			this.axiosClient.post<{
				accessToken: string
				auditInformation: { emailAddress: string }
				searchParameter: { nhsNumber?: string; dateOfBirth?: string }
			}>(`/api/sso/test/token`, body)
		)
}
